import React from 'react'
import { Link } from 'gatsby'

import Layout from '../../components/layout'
import Image from '../images/mike-bio.jpg'
import SEO from '../../components/seo'

const IndexPage = () => (
  <Layout>
    <SEO title="Michael S. Patterson, MD" keywords={[]} />
    <div id="main" role="main">
      {' '}
      <div id="content" style={{ display: 'inline-block' }}>
        <h1 className="page-title">Michael S. Patterson, MD</h1>
        <p>
          <img
            className="alignleft size-full wp-image-332"
            style={{ float: 'left' }}
            title="Mike S. Patterson, MD"
            src={Image}
            alt
            width={200}
            height={210}
          />
          As an Associate with Gómez and Associates, Dr. Patterson works with
          Senior Executives on leadership team alignment, fostering innovation
          and creativity, and helping individuals hone their own leadership
          effectiveness. Utilizing his experience in Fallujah Iraq when he was
          the Battalion Surgeon for the Marines’ 3rd Reconnaissance along with
          his ability as a master storyteller, he has developed a mesmerizing
          and audience engaging program called <em>Decision Points</em> to
          examine specific leadership competencies and real world challenges of
          senior leaders. Captain Patterson was in the reserves at the time he
          was called back up and deployed with the start of the war in Iraq. It
          is especially his situation of being the “ordinary citizen” and thrust
          into an “”extraordinary” situation that allows him to make such a
          strong connection despite the seemingly unrelated worlds of our
          audiences.
        </p>
        <p>
          Currently, Dr. Patterson works at Camino Entrada Pediatrics, part of
          St. Vincent Regional Medical Center in Santa Fe, New Mexico, serving
          Santa Fe and the northern New Mexico communities since September 1990.
          He provides care to children from newborn to eighteen years old.
          Additionally, he covers the hospital labor and delivery suites,
          pediatric inpatient unit and the emergency room. His broad range of
          responsibilities includes the initial stabilization of critically ill
          premature newborns, preparing them for transportation to more
          specialized neonatal intensive care units.
        </p>
        <p>
          Dr. Patterson was a member of the United States Navy and then the
          Reserves until January 2007. He provided care to military dependent
          and civilian children during annual training assignments in a variety
          of settings, including Naples and Sigonella, Italy, Rota, Spain,
          Guantanamo Bay, Cuba and Celica, Ecuador. Beyond pediatrics, his
          military experience included training with the United States Marine
          Corps. This included activities in Camp Pendleton, CA and Camp Fuji,
          Japan. In 2003 he was recalled to active duty as the medical officer
          for 1st Battalion, 25th Marines, in charge of 54 Navy corpsmen and one
          assistant battalion surgeon. In 2005, he was recalled a second time.
          As the battalion surgeon for 3rd Reconnaissance Battalion, he had 19
          Navy corpsmen in his medical department for this elite combat unit in
          the Anbar Province of Iraq.
        </p>
        <p>
          Dr. Patterson completed his undergraduate studies at Yale University.
          He attended medical school at the University of Colorado, receiving
          his MD in 1983. His internship in pediatrics was at Naval Hospital San
          Diego, CA. While on active duty with the Navy, he spent a year in
          Okinawa, Japan as a general medical officer with the Marines. Later
          hewas assigned to Naval Hospital Whidbey Island, WA, where his duties
          included pediatrics department head, chairman of child abuse committee
          and establishment of an air transport team for critically ill infants.
          Between his active and reserve duties, he served nearly 24 years.
        </p>
        <p>
          Phone: 719.447.4841 | Email:{' '}
          <a href="mailto:mike@gomezandassociates.com">
            mike@gomezandassociates.com
          </a>
        </p>
      </div>
    </div>
  </Layout>
)

export default IndexPage
